(function($) {

    if(Dropzone.isBrowserSupported()) {

        $.fn.imageuploader = function (options) {

            var $elem = this;
            var settings = $.extend({}, options);

            var $clickable = $elem.find('.upload-button');
            var $container = $elem.find('.upload-container');
            var $upload = $container.find('.upload');
            var template = $upload.get(0).outerHTML;
            $upload.remove();

            var myDropzone = new Dropzone($clickable.get(0), {
                url: "/api/images", // Set the url
                acceptedFiles: 'image/*',
                createImageThumbnails: false,
                maxFilesize: 100,
                parallelUploads: 1,
                maxFiles: 1,
                autoQueue: true,
                clickable: $clickable.get(0),
                previewTemplate: template,
                previewsContainer: $container.get(0)
            });

            myDropzone.on("sending", function (file, xhr, formData) {
                formData.append('_token', settings.csrftoken);
            });

            myDropzone.on("complete", function (file) {
                switch (file.status) {
                    case 'error':
                        fileError(file.xhr, file.previewElement);
                        break;
                    case 'success':
                        fileSuccess(file.xhr.responseText, file.previewElement);
                        break;
                }
            });


            function fileSuccess(data, element) {
                myDropzone.removeAllFiles();
                $elem.find('.upload-result').val(data);
                settings.callback();
            }


            function fileError(request, element) {
                $(element).find('.dz-upload').css('background-color', '#f00');
                setTimeout(function () {
                    myDropzone.removeAllFiles();
                    //$container.find('.upload').remove();
                }, 3000);
            }
        };

    } else {

        $.fn.imageuploader = function (options) {

            var $elem = this;
            var settings = $.extend({}, options);

            var $clickable = $elem.find('.upload-button');
            var $container = $elem.find('.upload-container');
            var $upload = $container.find('.upload');
            var template = $upload.get(0).outerHTML;
            $upload.remove();

            $('#upload-button').uploadify({
                'fileTypeDesc' : 'Image Files',
                'fileTypeExts' : '*.gif; *.jpg; *.png',
                'swf'      : '/assets/uploadify.swf',
                'uploader' : '/api/images',
                'formData' : { '_token' : settings.csrftoken},
                'fileObjName' : 'file',
                'onUploadSuccess': function(file, data, response) {
                    console.log(data);
                    $elem.find('.upload-result').val(data);
                    settings.callback();
                }
            });
        }

    }


}( jQuery ));